import { AUTH_CONFIG } from '@/config/constants';
import { readAccessTokenClaims } from '@/shared/access/tokenClaims';

/**
 * Impersonation flags are derived from the access-token claims, not localStorage.
 * localStorage can be edited in DevTools; the JWT still has to pass the API.
 * The backend ignores client role / impersonation headers and re-reads the JWT,
 * then checks impersonationSessionId against the database.
 */
export function getImpersonationState(token = localStorage.getItem(AUTH_CONFIG.TOKEN_STORAGE_KEY)) {
  const empty = {
    active: false,
    expired: false,
    exp: 0,
    sessionId: null,
    target: null,
    by: null,
  };
  const claims = readAccessTokenClaims(token);
  if (!claims?.isImpersonation) return empty;

  const exp = Number(claims.exp || 0);
  const expired = Boolean(exp && exp * 1000 <= Date.now());
  return {
    active: !expired,
    expired,
    exp,
    sessionId: claims.impersonationSessionId ? String(claims.impersonationSessionId) : null,
    target: claims.email ? String(claims.email) : null,
    by: claims.impersonatedBy != null ? String(claims.impersonatedBy) : null,
  };
}
